var _rect, _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 5.5,
    fill: "#FBFBFF",
    stroke: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8353 32.72L32.1153 31V24.3333C32.1153 20.24 29.9286 16.8133 26.1153 15.9067V15C26.1153 13.8933 25.222 13 24.1153 13C23.0086 13 22.1153 13.8933 22.1153 15V15.9067C18.2886 16.8133 16.1153 20.2267 16.1153 24.3333V31L14.3953 32.72C13.5553 33.56 14.142 35 15.3286 35H32.8886C34.0886 35 34.6753 33.56 33.8353 32.72ZM29.4486 32.3333H18.782V24.3333C18.782 21.0267 20.7953 18.3333 24.1153 18.3333C27.4353 18.3333 29.4486 21.0267 29.4486 24.3333V32.3333ZM24.1153 39C25.582 39 26.782 37.8 26.782 36.3333H21.4486C21.4486 37.0406 21.7296 37.7189 22.2297 38.219C22.7298 38.719 23.4081 39 24.1153 39Z",
    fill: "#797979"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3333,
    cy: 14.6667,
    r: 4.83333,
    fill: "#FF001F",
    stroke: "#FBFBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell2);
export default __webpack_public_path__ + "static/media/bell2.fac56deb12d273035faecabd1fdc8fe4.svg";
export { ForwardRef as ReactComponent };